(() => {
  let busy = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pg-offer-add]');
    if (!button || busy) return;
    event.preventDefault();
    busy = true;
    const text = button.textContent;
    const status = button.closest('.pg-cart-offers').querySelector('[role="status"]');
    const checkoutButtons = [...document.querySelectorAll('button[name="checkout"]')].filter((element) => !element.disabled);
    checkoutButtons.forEach((element) => { element.disabled = true; });
    button.disabled = true;
    button.textContent = button.dataset.pgLoading;
    status.textContent = '';
    try {
      const response = await fetch(button.dataset.pgAddUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.pgOfferAdd, quantity: 1 }] })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || button.dataset.pgError);
      const addedKey = data.items?.[0]?.key;
      await new Promise((resolve, reject) => {
        const containers = [...document.querySelectorAll('[data-products]')];
        let timer;
        const observer = new MutationObserver(check);
        function check() {
          const updated = addedKey && containers.length && containers.every((container) =>
            [...container.querySelectorAll('.cart__item')].some((item) => item.dataset.key === addedKey)
          );
          if (updated) {
            observer.disconnect();
            clearTimeout(timer);
            resolve();
          }
        }
        observer.observe(document.body, { childList: true, subtree: true });
        timer = setTimeout(() => {
          observer.disconnect();
          window.location.assign(button.dataset.pgAddUrl.replace(/add\.js$/, ''));
          reject(new Error(button.dataset.pgError));
        }, 7000);
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        check();
      });
    } catch (error) {
      status.textContent = error.message || button.dataset.pgError;
    } finally {
      busy = false;
      button.disabled = false;
      button.textContent = text;
      checkoutButtons.forEach((element) => { element.disabled = false; });
    }
  });
})();